import type { ActiveGameData, ActiveGameDataCash } from '@ps/web-poker-types';
import { ActiveGameButtonType, ActiveGameType } from '@ps/web-poker-types';
import type { TableData, ZoomDataStruct } from '@ps/web-shared-generated-graphql/AG';

import { formatGame } from './formatters/game';

const mapTableType = (data?: TableData | null): ActiveGameDataCash | undefined => {
  if (!data?.staticData) return undefined;

  return {
    id: data.staticData.tableId,
    name: data.staticData.name || '',
    gameFormat: formatGame(
      data.staticData.game,
      data.staticData.structure,
      Boolean(data.staticData.isHiLo),
      false
    ),
    type: ActiveGameType.Cash,
    buttonType: ActiveGameButtonType.UNREGISTER
  } as ActiveGameDataCash;
};

const mapZoomType = (data?: ZoomDataStruct | null): ActiveGameDataCash | undefined => {
  if (!data?.staticData) return undefined;

  return {
    id: data.staticData.id,
    name: data.staticData.name || '',
    gameFormat: formatGame(
      data.staticData.game,
      data.staticData.structure,
      Boolean(data.staticData.isHiLo),
      false
    ),
    type: ActiveGameType.Zoom,
    buttonType: ActiveGameButtonType.UNREGISTER
  } as ActiveGameDataCash;
};

const mapActiveGameTables = (data?: (TableData | null)[]): ActiveGameDataCash[] => {
  if (!data) return [];

  return data.map((item) => mapTableType(item)).filter((item) => !!item) as ActiveGameDataCash[];
};

const mapActiveGameZoomTypes = (data?: (ZoomDataStruct | null)[]): ActiveGameDataCash[] => {
  if (!data) return [];

  return data.map((item) => mapZoomType(item)).filter((item) => !!item) as ActiveGameDataCash[];
};

const getActiveGameTableIds = (data?: (TableData | null)[]): string[] => {
  if (!data) return [];

  return data.map((item) => `${item?.staticData?.tableId}`).filter((item) => !!item);
};

const getActiveGameZoomIds = (data?: (ZoomDataStruct | null)[]): string[] => {
  if (!data) return [];

  return data.map((item) => `${item?.staticData?.id}`).filter((item) => !!item);
};

export const getActiveGameIds = (data?: {
  tables?: (TableData | null)[];
  zoomTypes?: (ZoomDataStruct | null)[];
}): string[] => {
  if (!data) return [];

  return [...getActiveGameTableIds(data.tables), ...getActiveGameZoomIds(data.zoomTypes)].filter(
    (item) => !!item
  );
};

export const mapActiveGames = (data?: {
  tables?: (TableData | null)[];
  zoomTypes?: (ZoomDataStruct | null)[];
}): ActiveGameData[] => {
  if (!data) return [];

  return [...mapActiveGameTables(data.tables), ...mapActiveGameZoomTypes(data.zoomTypes)];
};
